import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import { ddStyles } from "../../utils/CommonStyles.js";


function DisplaySupplyChain() {
    const navigate = useNavigate();

    const [errorValue, setErrorValue] = useState("");
    const [delegates, setDelegates] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [supplierCompanyId, setSupplierCompanyId] = useState(0);
    const [supplierLoaded, setSupplierLoaded] = useState(false);
    const [supplierSelected, setSupplierSelected] = useState({ name: "supplierId", label: "", value: 0 });
    const [buyers, setBuyers] = useState([]);
    const [buyerOptions, setBuyerOptions] = useState([]);
    const [buyerLoaded, setBuyerLoaded] = useState(false);
    const [buyerSelected, setBuyerSelected] = useState({ name: "buyerId", label: "", value: 0 });
    const [buyerCompanyId, setBuyerCompanyId] = useState(0);
    const [count, setCount] = useState(0);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);

    const initialValues = {
        delegateKey: 0,
        partnerKey: 0,
        companyKey: 0,
    };

    const [editFormData, setEditFormData] = useState(initialValues);

    useEffect(() => {
        fetchBuyers();
    }, []);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    function fetchBuyers() {
        setErrorValue("");
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("FetchBuyers", "/Service/CompanyService/FetchBuyers", requestOptions, fetchBuyersSuccess, fetchBuyersFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function fetchBuyersFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.buyerListNotRetrieved"));
    }
    function fetchBuyersSuccess(responseData) {
        let fetchBuyersResponse;
        if (responseData) {
            fetchBuyersResponse = responseData.fetchBuyersResponse;
            if (fetchBuyersResponse && fetchBuyersResponse.errorCode === "0") {
                setBuyerValues(fetchBuyersResponse.companies);
                setBuyers(fetchBuyersResponse.companies);
            } else if (fetchBuyersResponse && fetchBuyersResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchBuyersResponse) {
                setErrorValue(t("error.error") + " " + fetchBuyersResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
    }

    function setSupplierValues(companyObj) {
        let companyValue = {};
        let companyOptionList = [];
        companyOptionList.push({ label: "", value: 0 });
        if (companyObj && companyObj.length > 0) {
            companyObj.map((company, index) => {
                companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
                companyValue.value = company.companyId;
                companyOptionList.push(companyValue);
                companyValue = {};
            });
        }
        setSupplierOptions(companyOptionList);
        setSupplierLoaded(true);
    }

    const supplierHandler = (selectedOption, action) => {
        let companyId = selectedOption ? selectedOption.value : 0;
        let companyName = selectedOption ? selectedOption.label : "";
        if (companyId === supplierCompanyId) {
            return;
        }
        setDelegates([]);
        setSupplierCompanyId(companyId);
        setSupplierSelected({ ...supplierSelected, label: companyName, value: companyId });
        setEditFormData({ ...editFormData, partnerKey: companyId });
    }

    function fetchCompanies(clientId) {
        setErrorValue("");
        if ((!clientId || clientId === 0)) {
            return;
        }
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false,
                excludeCompany: clientId
            }),
        };
        try {
            FetchUtil.fetchAPI("FetchCompanies", "/Service/CompanyService/FetchCompanies", requestOptions, retrieveCompaniesSuccess, retrieveCompaniesFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function retrieveCompaniesSuccess(responseData) {
        let fetchCompaniesResponse;
        if (responseData) {
            fetchCompaniesResponse = responseData.fetchCompaniesResponse;
            if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "0") {
                setSupplierValues(fetchCompaniesResponse.companies.slice());
                if (fetchCompaniesResponse.companies) {
                    setSuppliers(fetchCompaniesResponse.companies.slice());
                }
            } else if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchCompaniesResponse) {
                setErrorValue(t("error.error") + " " + fetchCompaniesResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
    }

    function retrieveCompaniesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.companyListNotRetrieved"));
    }

    function setBuyerValues(buyers) {
        let buyerValue = {};
        let buyerOptionList = [];
        buyerOptionList.push({ label: "", value: 0 });
        if (buyers && buyers.length > 0) {
            buyers.map((buyer, index) => {
                buyerValue.label = buyer.companyName + ', ' + (buyer.city ? buyer.city + ', ' : '') + buyer.stateCode + ', ' + buyer.countryCode;
                buyerValue.value = buyer.companyId;
                buyerOptionList.push(buyerValue);
                buyerValue = {};
            });
        }
        setBuyerOptions(buyerOptionList);
        setBuyerLoaded(true);
    }

    const buyerHandler = (selectedOption, action) => {
        let companyId = selectedOption ? selectedOption.value : 0;
        let companyName = selectedOption ? selectedOption.label : "";
        if (companyId === buyerCompanyId) {
            return;
        }
        setDelegates([]);
        setSupplierCompanyId(0);
        setSupplierSelected({ ...supplierSelected, label: "", value: 0 });
        setSuppliers([]);
        setSupplierOptions([]);
        setBuyerCompanyId(companyId);
        setBuyerSelected({ ...buyerSelected, label: companyName, value: companyId });
        setEditFormData({ ...editFormData, companyKey: companyId });
        if (companyId && companyId > 0) {
            fetchCompanies(companyId);// fetch all suppliers
        }
    }

    function fetchSupplyChain() {
        setErrorValue("");
        let companyId = editFormData.companyKey;
        if ((!companyId || companyId === 0)) {
            setErrorValue(t("error.buyer.Reqd"));
            return;
        }
        setIsLoading(true);
        resetCounter();
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true,
                supplierKey: supplierCompanyId,
                buyerCompanyId: companyId,
            }),
        };
        try {
            FetchUtil.fetchAPI("FetchSupplyChain", "/Service/CompanyService/FetchSupplyChain", requestOptions, fetchSupplyChainSuccess, fetchSupplyChainFail);
        } catch (error) {
            setIsLoading(false);
            throw new Error(error.message);
        }
    }

    function fetchSupplyChainFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.partnerDelegateNotRetrieved"));
    }

    function fetchSupplyChainSuccess(responseData) {
        let getSupplyChainResponse;
        if (responseData) {
            getSupplyChainResponse = responseData.getSupplyChainResponse;
            if (getSupplyChainResponse && getSupplyChainResponse.errorCode === "0") {
                if (getSupplyChainResponse.companyHierarchies) {
                    setDelegates([...getSupplyChainResponse.companyHierarchies]);
                } else {
                    setDelegates([]);
                }
            } else if (getSupplyChainResponse && getSupplyChainResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getSupplyChainResponse) {
                setErrorValue(t("error.error") + " " + getSupplyChainResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }

    const searchRecords = () => {
        reloadSupplierData();
    }

    function reloadSupplierData() {
        setDelegates([]);
        fetchSupplyChain();

    }
    return (
        <div className="container-fluid">
            <Header />
            <div className={"container-fluid container_list viewh-85"}>
                {(userCtx.role === "SiteAdmin") ?
                    <>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="inerrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <div id="placeholder_1" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="form-label">
                                        <span className="form_required">*</span>
                                        {t("page.buyer")}
                                    </label>
                                    <Select
                                        name="buyerId"
                                        options={buyerOptions}
                                        onChange={buyerHandler}
                                        placeholder={""}
                                        value={buyerSelected}
                                        isSearchable={buyerLoaded}
                                        isClearable={buyerLoaded}
                                        className="myselect"
                                        inputId="buyerId-input"
                                        styles={ddStyles}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <label className="form-label">
                                        {t("page.supplier")}
                                    </label>
                                    <Select
                                        name="supplierId"
                                        options={supplierOptions}
                                        onChange={supplierHandler}
                                        placeholder={""}
                                        value={supplierSelected}
                                        isSearchable={supplierLoaded}
                                        isClearable={supplierLoaded}
                                        className="myselect"
                                        inputId="supplierId-input"
                                        styles={ddStyles}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12 text-center">
                                <button type="submit"
                                    className="btn btn-primary btn-block search-button"
                                    onClick={searchRecords}>
                                    <span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
                                </button>
                            </div>
                            {(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div id="placeholder_2" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <table className="list-table" role="table">
                                    <thead>
                                        <tr role="row">
                                            <th className="list-th">{t("page.supplyChain")}</th>
                                        </tr>
                                    </thead>
                                    <tbody role="rowgroup">
                                        {delegates.length > 0 && (
                                            delegates.map((delegateItem, index) => (
                                                <tr key={count}>
                                                    <td className={((index % 2) > 0) ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{delegateItem}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="berrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>
                    </>
                    : null}
            </div>
            <div className="footer_container">
                <Footer />
            </div>
        </div>
    );
}

export default DisplaySupplyChain;